import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBIN } from '../models/models'

export class AddBinListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/card-bin/AddBinList',
      requesterInfo,
    })
  }

  public async AddBinNumber(BIN: IBIN[]): Promise<any> {
    return await this.postAsync<IBIN>(BIN)
  }
}
